import { __extends, __makeTemplateObject, __decorate, __metadata, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x, nothing as A } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { StandardSize, Size } from '../pvd-utils/enums/size.js';
import { TextAlign } from '../pvd-utils/enums/text-align.js';

var InputType;
(function (InputType) {
    InputType["email"] = "email";
    InputType["number"] = "number";
    InputType["password"] = "password";
    InputType["phone"] = "phone";
    InputType["tel"] = "tel";
    InputType["text"] = "text";
    InputType["url"] = "url";
    InputType["ssn"] = "ssn";
    InputType["zip"] = "zip";
})(InputType || (InputType = {}));
var DEFAULT_SIZE = StandardSize.medium;
var DEFAULT_TYPE = InputType.text;
var DEFAULT_TEXT_ALIGN = TextAlign.left;
var DEFAULT_REQUIRED = false;
var DEFAULT_ERROR = false;
var DEFAULT_DISABLED = false;
var INPUT_PROTECTED_ATTR_MAP = new Map([
    ['aria-describedby', 'pvd-aria-describedby'],
    ['aria-disabled', 'pvd-disabled'],
    ['aria-invalid', 'pvd-error'],
    ['aria-label', 'pvd-aria-label'],
    ['aria-required', 'pvd-required'],
    ['disabled', 'pvd-disabled'],
    ['id', 'pvd-id'],
    ['placeholder', 'pvd-placeholder'],
    ['required', 'pvd-required'],
    ['type', 'pvd-type'],
    ['value', 'pvd-value'],
]);
/**
 * Providence Input component.
 * @see {@link https://providence.fmr.com/components/input/input.html|Input documentation}
 */
var PvdInput = /** @class */ (function (_super) {
    __extends(PvdInput, _super);
    function PvdInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pvdDisabled = DEFAULT_DISABLED;
        _this.pvdError = DEFAULT_ERROR;
        _this.pvdRequired = DEFAULT_REQUIRED;
        _this.pvdSize = DEFAULT_SIZE;
        _this.pvdTextAlign = DEFAULT_TEXT_ALIGN;
        _this.pvdType = DEFAULT_TYPE;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdInput, "scopedElements", {
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                'pvd-scoped-icon': customElements.get("".concat(this.namespace, "-icon")),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdInput.prototype, "hasIconLeft", {
        // #endregion
        // #region private methods
        get: function () {
            return !!this.pvdIconLeft || this.isSlotUsed('icon-left');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdInput.prototype, "hasIconRight", {
        get: function () {
            return !!this.pvdIconRight || this.isSlotUsed('icon-right');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdInput.prototype, "iconSize", {
        get: function () {
            return this.pvdSize === StandardSize.large ? Size.medium : Size.small;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdInput.prototype, "inputType", {
        get: function () {
            switch (this.pvdType) {
                case InputType.phone:
                    return InputType.tel;
                case InputType.ssn:
                case InputType.zip:
                    return InputType.text;
                default:
                    return this.pvdType;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets attributes on the input element that are coming from pvdNativeInputAttributes
     * @param prevAttr optional, if user updates pvdNativeInputAttributes, this will remove/update existing attributes
     */
    PvdInput.prototype.setNativeInputAttributes = function (prevAttr) {
        var targetElement = this.querySelector('input');
        this.setNativeAttributes(this.pvdNativeInputAttributes, INPUT_PROTECTED_ATTR_MAP, targetElement, prevAttr);
    };
    /**
     * Callback to detect changes to the slotted content
     * @param event
     */
    PvdInput.prototype.onSlotChangeHandler = function (event) {
        this.requestUpdate();
    };
    // #endregion
    // #region events
    /**
     * Update the `pvdValue` property to match the new value of the <input> element
     * @param e
     */
    PvdInput.prototype.onInput = function (e) {
        this.pvdValue = e.target.value;
    };
    // #endregion
    // #region LitElement lifecycles
    PvdInput.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        if (this.pvdNativeInputAttributes) {
            var prevAttr = changedProperties.get('pvdNativeInputAttributes');
            // if native attributes are being set, go through the logic of applying attributes to target element
            this.setNativeInputAttributes(prevAttr);
        }
    };
    PvdInput.prototype.renderLeftIcon = function () {
        return this.hasIconLeft
            ? x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<span class=\"pvd-input__icon pvd-input__icon--left\"\n          ><s-slot name=\"icon-left\" @slotchange=\"", "\"\n            >", "</s-slot\n          ></span\n        >"], ["<span class=\"pvd-input__icon pvd-input__icon--left\"\n          ><s-slot name=\"icon-left\" @slotchange=\"", "\"\n            >", "</s-slot\n          ></span\n        >"])), this.onSlotChangeHandler, this.renderIcon(this.pvdIconLeft)) : x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<s-slot name=\"icon-left\" @slotchange=\"", "\"></s-slot>"], ["<s-slot name=\"icon-left\" @slotchange=\"", "\"></s-slot>"])), this.onSlotChangeHandler);
    };
    PvdInput.prototype.renderRightIcon = function () {
        return this.hasIconRight
            ? x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["<span class=\"pvd-input__icon pvd-input__icon--right\"\n          ><s-slot name=\"icon-right\" @slotchange=\"", "\"\n            >", "</s-slot\n          ></span\n        >"], ["<span class=\"pvd-input__icon pvd-input__icon--right\"\n          ><s-slot name=\"icon-right\" @slotchange=\"", "\"\n            >", "</s-slot\n          ></span\n        >"])), this.onSlotChangeHandler, this.renderIcon(this.pvdIconRight)) : x(templateObject_4 || (templateObject_4 = __makeTemplateObject(["<s-slot name=\"icon-right\" @slotchange=\"", "\"></s-slot>"], ["<s-slot name=\"icon-right\" @slotchange=\"", "\"></s-slot>"])), this.onSlotChangeHandler);
    };
    PvdInput.prototype.renderIcon = function (iconName) {
        if (!iconName) {
            return A;
        }
        return this.scopeTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["<pvd-scoped-icon\n      pvd-name=\"", "\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"], ["<pvd-scoped-icon\n      pvd-name=\"", "\"\n      pvd-size=\"", "\"\n    ></pvd-scoped-icon>"])), iconName, this.iconSize);
    };
    PvdInput.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-input-root"),
            modifierPrefix: 'pvd-input',
            modifiers: [
                {
                    condition: this.hasIconLeft,
                    className: 'icon-left',
                },
                {
                    condition: this.hasIconRight,
                    className: 'icon-right',
                },
                {
                    condition: this.pvdDisabled,
                    className: 'disabled',
                },
                {
                    condition: this.pvdError,
                    className: 'error',
                },
                {
                    condition: this.pvdFullWidth !== undefined,
                    className: "".concat(this.pvdFullWidth ? 'full' : 'fixed', "-width"),
                },
                {
                    condition: [InputType.phone, InputType.ssn, InputType.zip].indexOf(this.pvdType) !== -1,
                    className: this.pvdType,
                },
                {
                    condition: true,
                    className: "".concat(this.pvdSize),
                },
                {
                    condition: this.pvdTextAlign !== undefined,
                    className: "text-".concat(this.pvdTextAlign),
                },
            ],
        };
        return x(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      <div class=\"", "\">\n        ", "\n        <input\n          @input=", "\n          @blur=", "\n          @focus=", "\n          ?disabled=\"", "\"\n          ?required=\"", "\"\n          .value=\"", "\"\n          aria-describedby=\"", "\"\n          aria-disabled=\"", "\"\n          aria-invalid=\"", "\"\n          aria-label=\"", "\"\n          aria-required=\"", "\"\n          class=\"pvd-input__input\"\n          id=\"", "\"\n          placeholder=\"", "\"\n          title=\"\"\n          type=\"", "\"\n        />\n        ", "\n      </div>\n    "], ["\n      <div class=\"", "\">\n        ", "\n        <input\n          @input=", "\n          @blur=", "\n          @focus=", "\n          ?disabled=\"", "\"\n          ?required=\"", "\"\n          .value=\"", "\"\n          aria-describedby=\"", "\"\n          aria-disabled=\"", "\"\n          aria-invalid=\"", "\"\n          aria-label=\"", "\"\n          aria-required=\"", "\"\n          class=\"pvd-input__input\"\n          id=\"", "\"\n          placeholder=\"", "\"\n          title=\"\"\n          type=\"", "\"\n        />\n        ", "\n      </div>\n    "])), getClassName(classMap), this.renderLeftIcon(), this.onInput, this.bubbleEvent, this.bubbleEvent, this.pvdDisabled, this.pvdRequired, l(this.pvdValue), l(this.pvdAriaDescribedby), l(this.a11yBoolean(this.pvdDisabled)), l(this.a11yBoolean(this.pvdError)), l(this.pvdAriaLabel), l(this.a11yBoolean(this.pvdRequired)), l(this.pvdId), l(this.pvdPlaceholder), this.inputType, this.renderRightIcon());
    };
    //#region Component configuration
    PvdInput.componentName = 'input';
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-describedby' }),
        __metadata("design:type", String)
    ], PvdInput.prototype, "pvdAriaDescribedby", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-label' }),
        __metadata("design:type", String)
    ], PvdInput.prototype, "pvdAriaLabel", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-disabled' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disabled'))),
        __metadata("design:type", Boolean)
    ], PvdInput.prototype, "pvdDisabled", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-error' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-error'))),
        __metadata("design:type", Boolean)
    ], PvdInput.prototype, "pvdError", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-full-width' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-full-width'))),
        __metadata("design:type", Boolean)
    ], PvdInput.prototype, "pvdFullWidth", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-icon-left' }),
        __metadata("design:type", String)
    ], PvdInput.prototype, "pvdIconLeft", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-icon-right' }),
        __metadata("design:type", String)
    ], PvdInput.prototype, "pvdIconRight", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-id' }),
        __metadata("design:type", String)
    ], PvdInput.prototype, "pvdId", void 0);
    __decorate([
        n({ type: Object, attribute: 'pvd-native-input-attributes' }),
        __metadata("design:type", Object)
    ], PvdInput.prototype, "pvdNativeInputAttributes", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-placeholder' }),
        __metadata("design:type", String)
    ], PvdInput.prototype, "pvdPlaceholder", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-required' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-required'))),
        __metadata("design:type", Boolean)
    ], PvdInput.prototype, "pvdRequired", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-size' }, PvdSlotifyBaseComponent.hasChanged(StandardSize))),
        __metadata("design:type", Number)
    ], PvdInput.prototype, "pvdSize", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-text-align' }, PvdSlotifyBaseComponent.hasChanged(TextAlign))),
        __metadata("design:type", String)
    ], PvdInput.prototype, "pvdTextAlign", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-type' }, PvdSlotifyBaseComponent.hasChanged(InputType))),
        __metadata("design:type", String)
    ], PvdInput.prototype, "pvdType", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-value' }),
        __metadata("design:type", String)
    ], PvdInput.prototype, "pvdValue", void 0);
    return PvdInput;
}(ScopedElementsMixin(PvdSlotifyBaseComponent)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { DEFAULT_DISABLED, DEFAULT_ERROR, DEFAULT_REQUIRED, DEFAULT_SIZE, DEFAULT_TEXT_ALIGN, DEFAULT_TYPE, INPUT_PROTECTED_ATTR_MAP, InputType, PvdInput };
